<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-header="false"
      :width="dialogWidth"
      :modal="false"
      custom-class="cookie-consent-dialog"
    >
      <div class="cookie-consent">
        <h3 class="cookie-title">{{ $t('cookieNotice.title') }}</h3>
        <p class="cookie-message">
          <!-- 我们使用 Cookie 来提升您的浏览体验。继续使用本网站即表示您同意我们的 -->
          {{ $t('cookieNotice.description') }}
          <span class="cookie-link" @click="goto">{{ $t('cookieNotice.cookiePolicy') }}</span
          >
        </p>

        <div class="cookie-actions">
          <el-button type="primary" @click="acceptAll" class="cookie-button accept-all">
            <!-- 接受所有 Cookie -->
            {{ $t('cookieNotice.acceptAll') }}
          </el-button>
          <el-button @click="acceptNecessary" class="cookie-button accept-necessary">
            <!-- 仅接受必要 Cookie -->
            {{ $t('cookieNotice.acceptNecessary') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
    <cookie-preferences
      :visible.sync="showPreferences"
      @save-preferences="handleSavePreferences"
      @cancel="handleCancelPreferences"
    />
  </div>
</template>

<script>
import CookiePreferences from './CookiePreferences.vue';
export default {
  name: 'CookieConsent',
  components: {
    CookiePreferences
  },
  data() {
    return {
      showPreferences: false,
      dialogVisible: false,
      dialogWidth: '600px' // 默认桌面端宽度
    };
  },
  mounted() {
    this.checkMobile(); // 检测是否是移动端
    if (!this.getCookie('cookie_consent')) {
      this.dialogVisible = true;
    }
  },
  methods: {
    goto() {
      this.$router.push({ name: 'cookiePriva' });
    },
    // 检测是否是移动端
    checkMobile() {
      const isMobile = window.matchMedia('(max-width: 768px)').matches;
      this.dialogWidth = isMobile ? '90%' : '600px'; // 移动端宽度自适应
    },

    // 设置 Cookie
    setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      const expires = 'expires=' + date.toUTCString();
      document.cookie = `${name}=${value};${expires};path=/`;
    },

    // 获取 Cookie
    getCookie(name) {
      const cookieName = `${name}=`;
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();
        if (cookie.indexOf(cookieName) === 0) {
          return cookie.substring(cookieName.length, cookie.length);
        }
      }
      return null;
    },

    // 接受所有 Cookie
    acceptAll() {
      this.setCookie('cookie_consent', 'all', 365);
      this.dialogVisible = false;
    },

    // 仅接受必要 Cookie
    acceptNecessary() {
      //   this.setCookie('cookie_consent', 'necessary', 365);
      //   this.dialogVisible = false;
      this.showPreferences = true;
    },
    handleSavePreferences(preferences) {
      console.log('保存的Cookie偏好:', preferences);
      this.setCookie('cookie_consent', 'necessary', 365);
      this.dialogVisible = false;
      // 这里可以保存到本地存储或发送到服务器
      // 根据选择设置cookie
    },
    handleCancelPreferences() {
      // 可以在这里处理取消逻辑
    }
  }
};
</script>

<style scoped lang="less">
/* 基础样式 */
.cookie-consent {
  //   padding: 0 20px 20px;
  text-align: center;
}

.cookie-title {
  margin-top: 0;
  margin-bottom: 15px;
  color: #333;
  font-size: 30px; /* 桌面端标题大小 */
}

.cookie-message {
  margin-bottom: 20px;
  color: #666;
  line-height: 1.5;
  font-size: 26px; /* 桌面端正文大小 */
}

.cookie-link {
  color: #409eff;
  text-decoration: none;
  cursor: pointer;
  display: flex;
  flex-wrap: wrap;
}

.cookie-link:hover {
  text-decoration: underline;
}

.cookie-actions {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10px; /* 按钮间距 */
}

.cookie-button {
  //   padding: 10px 20px;
  font-size: 26px;
}

.cookie-consent-dialog .el-dialog__body {
  padding: 20px;
}

@media (min-width: 981px) {
  /deep/ .el-dialog {
    position: fixed;
    bottom: 50px;
    right: 50px;
    margin-top: 0 !important;
    margin-bottom: 0;
  }
  // /deep/ .el-button {
  //   word-break: break-all;
  //   white-space: '';
  // }

  .cookie-actions .el-button {
    white-space: normal; /* 允许换行 */
    word-break: break-word; /* 允许在单词内换行 */
    height: auto; /* 高度自适应 */
    padding: 10px 15px; /* 调整内边距，避免文字贴边 */
    line-height: 1.4; /* 调整行高，使多行文字更美观 */
  }
}

@media (max-width: 980px) {
  /deep/ .el-dialog {
    width: 100% !important; /* 移动端弹窗宽度 */
    max-width: 100%;
    position: fixed;
    bottom: 0;
    margin: 0;
  }

  .cookie-title {
    font-size: 32px; /* 移动端标题缩小 */
  }

  .cookie-message {
    font-size: 28px; /* 移动端正文缩小 */
  }

  .cookie-actions {
    display: flex;
    /* flex-direction: column; 
    gap: 8px; */
  }

  .cookie-button {
    width: 100%; /* 移动端按钮占满宽度 */
    padding: 12px;
  }
}

/deep/ .el-dialog__header {
  display: none;
}
</style>
